export const ViewsChartTooltip = ({ active, payload, label, type = "profile_view" }) => {

  if (active && payload && payload.length) {
    return (
      <div className="bg-white rounded-md shadow-lg flex items-center divide-x p-2">
        <span className='text-brand-alt pr-2'>{label}</span>
        <div className='pl-2 flex flex-col'>
          {type === "profile_view" && <span className='text-brand font-bold'>{payload[0].payload.profile_view ?? 0} Profile views</span>}
          {type === "search" && <span className='text-sm'>{payload[0].payload.search ?? 0} Search results</span>}
        </div>
      </div>
    );
  }

  return null;
};
